import PropTypes from "prop-types";
import { connect } from "react-redux";
import { changeSort, setSortFocus } from "../../../../state/actions";
import {
  getSort as getSortFromState,
  getSortOrder as getSortOrderFromState,
  getSortFocus as getSortFocusFromState
} from "../../../../state/selectors";
import SortSelect from "../../../presentational/common/SortSelect";
import {
  mapDisplaySortToState,
  mapStateSortToDisplay
} from "../../../../savedItemsSortConfig";
import { useSortSearchParam } from "./useSortSearchParam";

const mapStateToProps = state => ({
  displayValue: mapStateSortToDisplay({
    sort: getSortFromState(state),
    sortOrder: getSortOrderFromState(state)
  }),
  focus: getSortFocusFromState(state)
});

const mapDispatchToProps = dispatch => ({
  changeSort: ({ sort }) => {
    const sortOption = mapDisplaySortToState(sort);
    dispatch(changeSort(sortOption));
  },
  onBlur: () => dispatch(setSortFocus(false))
});

const SortSelectContainer = ({ changeSort, displayValue, focus, onBlur }) => {
  const { setValue } = useSortSearchParam({ changeSort, displayValue });

  return (
    <SortSelect
      setValue={setValue}
      value={displayValue}
      focus={focus}
      onBlur={onBlur}
    />
  );
};

SortSelectContainer.propTypes = {
  changeSort: PropTypes.func.isRequired,
  displayValue: PropTypes.string.isRequired,
  focus: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SortSelectContainer);
